import { ModalView, Button } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './index.css';
import { IDealRentSuccessModalProps } from './typings';

const successIcon = require('./success.svg') as string;

export const DealRentSendSimilarModal = ({ isOpen, offerId, closeModal, sendForm }: IDealRentSuccessModalProps) => {
  const send = React.useCallback(() => {
    const { referrer } = document;
    sendForm({ offerId, referrer });
  }, [offerId, sendForm]);

  return (
    <ModalView onClose={closeModal} custom={{ open: isOpen, mediaType: 'desktop' }}>
      <div className={styles['container']}>
        <img src={successIcon} />
        <h1 className={styles['title']}>Отправить анкету на похожие квартиры?</h1>
        <div className={styles['text']}>
          Ваша анкета отправлена. Мы можем автоматически отправить вашу анкету на похожие квартиры
        </div>
        <div className={styles['buttons-wrap']}>
          <div className={styles['button-wrap']}>
            <Button custom={{ type: 'primary', mediaType: 'mobile' }} onClick={send}>
              Отправить
            </Button>
          </div>
          <div className={styles['button-wrap']}>
            <Button custom={{ type: 'primary', mediaType: 'mobile' }} onClick={closeModal}>
              Не отправлять
            </Button>
          </div>
        </div>
      </div>
    </ModalView>
  );
};
